import * as React from 'react';

import FilePages32 from './FilePages32';

export const filePages32 = () => <FilePages32 />;

export default {
    title: 'Icon/Content/FilePages32',
    component: FilePages32,
    parameters: {
        notes: "`import FilePages32 from 'box-ui-elements/es/icon/content/FilePages32';`",
    },
};
